import { Route, Routes } from 'react-router';
import ApplicationDetailsPage from '../pages/ApplicationDetailsPage';
import ApplicationEvaluationsPage from '../pages/ApplicationEvaluationsPage';
import OnboardApplicationPage from '../pages/OnboardApplicationPage';

const ApplicationRoutes = () => {
  return (
    <Routes>
      <Route>
        <Route path="" element={<ApplicationEvaluationsPage />} />
        <Route path=":id" element={<ApplicationDetailsPage />} />
        <Route path="onboard" element={<OnboardApplicationPage />} />
      </Route>
    </Routes>
  );
};

export default ApplicationRoutes;
